import Config from 'Config';

const ADMIN_CONTACT = '/admin_contact';
const R101_ADMIN = Config.Environment.R101_ADMIN_URL;
const MARKETING = Config.Environment.R101_MARKETING_URL;
const ZENDESK = 'https://help.remind.com/hc/en-us';
const GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.remind101&referrer=utm_source%3Dremind101%26utm_medium%3D%252Fapps%26utm_campaign%3Dget-it-on-google-play';

const ENGAGEMENT_RATINGS_HC = `${ZENDESK}/articles/360006079220`;
const SETUP_SFTP = `${ZENDESK}/articles/360001678150`;

const LinkConstants = {
  REQUEST_SCHOOL_FORM:
    'https://docs.google.com/forms/d/1vxQRlF7IbLgfogmPM0d1Fm3yvGKhowXgzYQzIw8aI0s/viewform?edit_requested=true',
  ADMIN_CONTACT,
  ADMIN_UPGRADE_FORM:
    'https://docs.google.com/forms/d/e/1FAIpQLSei36UlbRpTKWOSznvLK7YzrCauyoZKg82BLLz7bmI_KrwC2A/viewform',
  MARKETING,
  SIGN_UP: `${MARKETING}/sign_in`,
  ABOUT: `${MARKETING}/about`,
  BLOG: `${MARKETING}/blog`,
  CAREERS: `${MARKETING}/about#careers`,
  COMMUNITY: `${MARKETING}/community`,
  COMMUNITY_GUIDELINES: `${MARKETING}/community-guidelines`,
  ENGAGEMENT_RATINGS: `${MARKETING}/engagement-ratings`,
  FAMILIES: `${MARKETING}/families`,
  FEATURES: `${MARKETING}/features`,
  HIGHER_EDUCATION: `${MARKETING}/higher-education`,
  HOW_IT_WORKS_TEACHERS: `${MARKETING}/how-it-works/teachers`,
  PLANS: `${MARKETING}/plans`,
  PLANS_GRID: `${MARKETING}/plans#plans-grid`,
  MOBILE_PLANS: `${MARKETING}/settings/remind_plans`,
  PLANS_CONTACT: 'plans@remind101.com',
  PARTNERS: `${MARKETING}/partners`,
  PRESS: `${MARKETING}/press`,
  PRIVACY_POLICY: `${MARKETING}/privacy-policy`,
  RESOURCES: `${MARKETING}/resources`,
  SCHOOLS: `${MARKETING}/schools`,
  TEACH_SMALL: `${MARKETING}/teach-small`,
  TEACHERS: `${MARKETING}/teachers`,
  TRUST_SAFETY: `${MARKETING}/trust-safety`,
  TERMS_OF_SERVICE: `${MARKETING}/terms-of-service`,
  DISTRICT_AGREEMENT: `${MARKETING}/district-agreement`,
  SCHOOL_AGREEMENT: `${MARKETING}/school-agreement`,
  JOIN: `${MARKETING}/join`,
  DATA_PRACTICE: `${MARKETING}/data-practices`,
  SUPPORT_CALL: `${MARKETING}/f/support_call`,
  MERGING_USER_COMPLETE: `${MARKETING}/classes`,

  APP_DOWNLOAD: 'http://rmd.me/a',
  HELP: 'https://help.remind.com',

  BILLING_EMAIL: 'billing@remindhq.com',
  DISTRICTS_EMAIL: 'districts@remind.com',
  REPORT_EMAIL: 'report@remindhq.com',
  SCHOOLS_EMAIL: 'schooladmin@remindhq.com',
  SUPPORT_EMAIL: 'support@remindhq.com',

  FACEBOOK: 'https://facebook.com/remindhq',
  TWITTER: 'https://twitter.com/remindhq',
  INSTAGRAM: 'https://instagram.com/remindhq',
  PINTEREST: 'https://pinterest.com/remindhq',
  YOUTUBE: 'https://youtube.com/remindhq',
  LINKEDIN: 'https://www.linkedin.com/company/remind101',
  GOOGLE_PLUS: 'https://plus.google.com/+remindhq',

  APP_STORE: 'https://itunes.apple.com/us/app/remind101/id522826277',
  GOOGLE_PLAY,
  MAC_APP_STORE: 'https://itunes.apple.com/us/app/remind-safe-classroom-communication/id1059891751',
  IOS_APP_OR_APP_STORE: 'https://remind.com/remind_ios_app_store',
  ANDROID_APP_OR_APP_STORE: `intent://a#Intent;scheme=rmd;package=com.remind101;S.browser_fallback_url=${encodeURI(
    GOOGLE_PLAY
  )};end`,

  UTM_SOURCE_ADMIN: 'remind_admin',
  UTM_SOURCE_TEACHER: 'remind_teacher',
  UTM_SOURCE_UPGRADE_MODAL: 'upgrade_modal',
  UTM_MEDIUM_PRODUCT: 'product',
  UTM_CAMPAIGN_UNPAID_ORG: 'admin_unpaid_organization',
  UTM_CAMPAIGN_TEACHER_UPSELL: 'teacher_upsell_unpaid_organization',
  UTM_CAMPAIGN_CLASS_LIMITS: 'class_limits_upgrade',

  ZENDESK,
  ADMIN_INTEGRATIONS_HELP: `${ZENDESK}/articles/360015003179-Setting-up-video-app-integrations`,
  ADMIN_ROLE_CHANGE: `${ZENDESK}/articles/4415935285901`,
  ARCHIVE_OR_REMOVE_CLASS: `${ZENDESK}/articles/4538470138125-How-do-I-archive-or-remove-classes-from-my-organization-`,
  AUTO_MESSAGING_HELP: `${ZENDESK}/articles/360003789559`,
  APPROVALS_LEARN_MORE: `${ZENDESK}/articles/4421682336909`,
  CLAIM_DEVICE_HELP: `${ZENDESK}/articles/360000633160-Combine-multiple-Remind-accounts`,
  CLASS_APPROVALS_HELP: `${ZENDESK}/articles/4421682336909`,
  CLASS_CODES: `${ZENDESK}/articles/202685535`,
  CHAT_RESTRICTIONS: `${ZENDESK}/articles/209063506`,
  CONNECT_SIS_CLEVER: `${ZENDESK}/articles/115001644730`,
  CONNECT_SIS_CLASSLINK: `${ZENDESK}/articles/4403934969869`,
  CONVERSATION_MESSAGE_HISTORY: `${ZENDESK}/articles/360000665859-How-do-I-retrieve-message-history-`,
  CUSTOMIZED_MESSAGING_HELP: `${ZENDESK}/articles/360003789559-How-can-I-create-and-send-auto-messages-#h_01FX0NDTMQSPY6FNB57NSTAAAZ`,
  DEFAULT_CLASS_SETTINGS_HELP: `${ZENDESK}/articles/360010513520`,
  DELIVERY_SUMMARY: `${ZENDESK}/articles/206227366`,
  DIRECT_ADD_ERROR: `${ZENDESK}/articles/201816825`,
  ENABLE_COOKIES: `${ZENDESK}/articles/203136915`,
  ENGAGEMENT_RATINGS_HC,
  ENGAGEMENT_RATINGS_HC_NO_RATING: `${ENGAGEMENT_RATINGS_HC}#no_rating`,
  ENGAGEMENT_REPORTS: `${ZENDESK}/articles/360016256720`,
  FORGOT_PASSWORD: `${ZENDESK}/articles/201920345`,
  FORMAT_ONEROSTER: `${ZENDESK}/articles/360001395940`,
  FORMAT_REMIND: `${ZENDESK}/articles/360000118400`,
  FORMAT_REMINDV2: `${ZENDESK}/articles/360013836460`,
  FORMAT_CLASSLINK: `${ZENDESK}/articles/4403934969869`,
  FORMAT_AERIES: `${ZENDESK}/articles/4421906463757`,
  FORMAT_SKYWARD: `${ZENDESK}/articles/16783632520845`,
  FREE_PRODUCT_LIMITS: `${ZENDESK}/articles/360005473379-What-are-class-and-participant-limits-`,
  LEAVE_CLASS: `${ZENDESK}/articles/200936349`,
  LINK_CLASS_TO_SCHOOL: `${ZENDESK}/articles/207536236`,
  INCREASE_ENGAGEMENT: `${ZENDESK}/articles/360000105700`,
  MANAGE_PROFILE: `${ZENDESK}/articles/4415935285901-How-do-I-change-the-role-of-school-participants-`,
  MERGE_ACCOUNTS: `${ZENDESK}/articles/360000633160`,
  MESSAGE_HISTORY_HELP: `${ZENDESK}/articles/203179807`,
  MOG: `${ZENDESK}/articles/203179827`,
  NO_DEVICES: `${ZENDESK}/articles/206430755`,
  PARENTAL_CONSENT: `${ZENDESK}/articles/210737926`,
  PARTICIPANT_MESSAGE_HISTORY: `${ZENDESK}/articles/360018462679-How-do-I-get-message-history-for-a-participant-`,
  PENDING_CLASSES: `${ZENDESK}/articles/4538470138125`,
  PENDING_ROLES: `${ZENDESK}/articles/360005941860`,
  PREFERRED_LANGUAGE_SETTING: `${ZENDESK}/articles/360018283580`,
  PREFERRED_LANGUAGE_FAQS: `${ZENDESK}/articles/4410165289485-Preferred-language-translation-FAQs#h_01GY0YXTN03540247NDDBDGMG9`,
  REQUEST_TO_JOIN: `${ZENDESK}/articles/360009013520`,
  FORMAT_RESOLVE_REMINDV2: `${ZENDESK}/articles/360014402739`,
  REACHABILITY_HELP: `${ZENDESK}/articles/204797195`,
  ROSTERING_ENFORCEMENT: `${ZENDESK}/articles/360009403279`,
  ROSTERING_GUIDE: `${ZENDESK}/articles/115001899304`,
  ROSTERING_HOLDS: `${ZENDESK}/articles/360000123860`,
  SELECTING_SCHOOL: `${ZENDESK}/articles/207536236`,
  SELF_ROLE_CHANGE: `${ZENDESK}/articles/201742425`,
  SENDING_TRANSLATED_MESSAGES: `${ZENDESK}/articles/360057686791`,
  SETUP_SFTP,
  SETUP_SFTP_DIRECT_SYNC: `${SETUP_SFTP}-Set-up-a-direct-sync-via-SFTP`,
  SOCIAL_MEDIA_INTEGRATION_HELP: `${ZENDESK}/articles/5160222212749`,
  SUPPORTED_BROWSERS: `${ZENDESK}/articles/201393549`,
  TRANSLATIONS_TOOLTIP_HELP: `${ZENDESK}/articles/360018283580`,
  TRANSLATIONS_TOOLTIP_NO_PREFERENCE_HELP: `${ZENDESK}/articles/360058109271`,
  UNCLAIMED_GROUPS: `${ZENDESK}/articles/360010078559`,
  UNMATCHED_STUDENTS: `${ZENDESK}/articles/360000719959`,
  UNREACHABLE_DEVICES: `${ZENDESK}/articles/360001686959`,
  UNREAD_NOTIFICATIONS: `${ZENDESK}/articles/360006004340`,
  UPDATE_SIS: `${ZENDESK}/articles/360000336184`,
  URGENT_MESSAGING_HELP: `${ZENDESK}/articles/360006252139`,
  WHAT_IS_REMIND: `${ZENDESK}/articles/201342445`,
  WIDGET_INSTRUCTIONS: `${ZENDESK}/articles/204876696`,
  ZENDESK_PLANS: `${ZENDESK}/categories/360000009170`,
  SOCIAL_MEDIA_SETUP: `${ZENDESK}/articles/5160222212749`,
  SURVEYS_LEARN_MORE: `${ZENDESK}/articles/6713940797837`,
  TOO_MANY_ATTACHMENTS_LEARN_MORE: 'https://help.remind.com/hc/en-us/articles/202550638',

  WHAT_ARE_ALL_ROLES_ON_REMIND:
    'https://help.remind.com/hc/en-us/articles/209063506-What-are-all-the-roles-on-Remind-#h_01FPB1PPGJQFD3ZW7YGGV5V5E8',

  CONTACT_FORM: `${ZENDESK}/requests/new`,

  DOWNLOAD_CHROME: 'https://www.google.com/chrome/browser/desktop/',
  DOWNLOAD_FIREFOX: 'https://www.getfirefox.com/',

  SYNC_SETUP_CALLBACK_URL: `${MARKETING}/v2/users/auth/external_api/sync_setup/callback`,
  CLASSLINK_APPLICATIONS: 'https://myapps.classlink.com/home',
  CLASSLINK_SUPPORT: 'https://help.classlink.com',
  CLASSLINK_DATA_SHARING_HELP:
    'https://classlink.zendesk.com/hc/en-us/articles/115002787414-Assigning-Applications',
  CLASSLINK_ADD_REMIND: 'https://myapps.classlink.com/home',

  CLEVER_ADD_REMIND: 'https://schools.clever.com/applications/add/remind',
  CLEVER_DATA_SHARING: 'https://schools.clever.com/school/applications/remind/sharing',
  CLEVER_DATA_SHARING_HELP:
    'https://support.clever.com/hc/en-us/articles/203115007-How-do-I-set-my-sharing-permissions-for-applications',
  CLEVER_SUPPORT_DISTRICT_ADMIN: 'https://support.clever.com/hc/en-us/categories/200147297',
  CLEVER_SUPPORT: 'https://support.clever.com/hc/en-us/requests/new',
  CLEVER_APPLICATIONS: 'https://schools.clever.com/applications',
  CLEVER_TEACHER_NOTIFICATION: `${ZENDESK}/articles/360000066310`,
  CLEVER_STUDENT_NOTIFICATION: `${ZENDESK}/articles/360000991644`,

  CLAIMING_CLASSES_HELP_ARTICLE: 'https://help.remind.com/hc/en-us/articles/18373983932429',
  NOTIFYING_UNCLAIMED_CLASS_OWNERS_HELP_ARTICLE:
    'https://help.remind.com/hc/en-us/articles/360010078559-See-rostered-classes-that-have-not-been-claimed',
  CLAIMING_CLASSES_HEADER_HELP_ARTICLE:
    'https://help.remind.com/hc/en-us/articles/360010078559-See-rostered-classes-that-have-not-been-claimed',

  PLANS_OPTIONS: 'https://plans.remind.com/RenewalsQ22020_Renewal-Options.html',

  PARENT_ONBOARDING_VIDEO: 'https://www.youtube.com/watch?v=dYpFv-JnT0s',
  DIRECT_ADD_VIDEO: 'https://www.youtube.com/watch?v=hRIFV-r6RM8',

  NCES: 'https://nces.ed.gov',

  CONTACT_HELP: 'https://help.remind.com/hc/en-us/requests/new',

  ENABLE_SIS_ROSTERING_ENFORCEMENT:
    'https://help.remind.com/hc/en-us/articles/360009403279-Enable-SIS-rostering-enforcement',

  SIS_SYNC_HELP: 'https://rmd.me/help',

  CONTACT_INFO_HELP: 'https://help.remind.com/hc/en-us/articles/4414984589709',

  R101_ADMIN_USER_BY_UUID_URL: `${R101_ADMIN}/admin/users?utf8=%E2%9C%93&q%5Buuid_equals%5D=`,
  MOBILE_WEB_CHAT_LINK: `${MARKETING}/chat`,

  STRIPE_TRANSACTIONS_DASHBOARD: 'https://dashboard.stripe.com/balance',
};

// Deduplicate
export const FooterLinks = {
  // Products
  CHAT: `${MARKETING}/chat`,
  HUB: `${MARKETING}/hub`,

  // Download
  APP_STORE: 'https://itunes.apple.com/us/app/remind101/id522826277',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.remind101',

  // Who its for
  TEACHERS: `${MARKETING}/teachers`,
  ADMINISTRATORS: `${MARKETING}/administrators`,
  HIGHER_EDUCATION: `${MARKETING}/higher-education`,
  FAMILIES: `${MARKETING}/families`,

  // Resources
  RESOURCES: `${MARKETING}/resources`,
  HELP_CENTER: ZENDESK,
  BLOG: `${MARKETING}/blog`,

  CONTACT_SUPPORT: `${ZENDESK}/requests/new`,
  CONTACT_SALES: `${MARKETING}/admin-contact`,
  SYSTEM_STATUS: `https://status.remind.com`,

  // Company
  ABOUT: `${MARKETING}/about`,
  CAREERS: `${MARKETING}/careers`,
  PRESS: `${MARKETING}/press`,
  PARTNERS: `${MARKETING}/partners`,
  TERMS_OF_SERVICE: `${MARKETING}/terms-of-service`,
  TRUST_SAFETY: `${MARKETING}/trust-safety`,
};

export const ConstructedLinks = {
  PLANS_GRID_FROM_FREE_PRODUCT_LIMITS: `${LinkConstants.PLANS}?utm_source=${LinkConstants.UTM_SOURCE_UPGRADE_MODAL}&utm_medium=${LinkConstants.UTM_MEDIUM_PRODUCT}&utm_campaign=${LinkConstants.UTM_CAMPAIGN_CLASS_LIMITS}#plans-grid`,
};

export default LinkConstants;
